/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AddAppointment from './AddAppointment/index'
import AppointmentHistory from './AppointmentHistory/index'
import ChangeAppointmentDuration from './ChangeAppointmentDuration/index'
import Delete from './Delete/index'
import GenerateLetters from './GenerateLetters/index'
import MoveToAnotherTreatment from './MoveToAnotherTreatment/index'
import React from 'react'
import ScheduleViaSmsOrEmail from './ScheduleViaSmsOrEmail/index'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/More/Content",
  onSubmit
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'AppointmentHistory'
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let optionsSubmitData = fromData.useDataSubmit({ viewPath,
context: 'options',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 data="options"
 onClick={optionsSubmitData}
 from={optionsValueData}
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 left="-230px"
 height="auto"
 width={250}
 valueWidth="auto"
 selectedBackgroundColor="transparent"
 alignSelf="center"
 marginLeft={dtSpaceXxs}
/>
<fromFlow.When is={flowValue === 'AppointmentHistory'}>
<AppointmentHistory
  viewPath={`${viewPath}/AppointmentHistory`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AddAppointment'}>
<AddAppointment
  viewPath={`${viewPath}/AddAppointment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ScheduleViaSmsOrEmail'}>
<ScheduleViaSmsOrEmail
  viewPath={`${viewPath}/ScheduleViaSmsOrEmail`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'GenerateLetters'}>
<GenerateLetters
  viewPath={`${viewPath}/GenerateLetters`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Delete'}>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MoveToAnotherTreatment'}>
<MoveToAnotherTreatment
  viewPath={`${viewPath}/MoveToAnotherTreatment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ChangeAppointmentDuration'}>
<ChangeAppointmentDuration
  viewPath={`${viewPath}/ChangeAppointmentDuration`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}